/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
const $ = require('jquery')
const _ = require('underscore')
const trans = require('trans')
const win = require('Helpers/win')
const { get } = require('ajax')
const Overlay = require('UI/Overlay')
const trans3d = require('Helpers/trans3d')
const killEvent = require('Helpers/killEvent')

require('tpl')
const simpleDialogTpl = require('../Block/simple_dialog.html.twig')

const simpleDialogDefaults = {
  type: undefined, // confirm || message || ...
  title: 'Dialog',
  content: '',
  contentEl: undefined,
  overlayZIndex: undefined,
  url: false,
  urlAsJson: false,
  iframe: false,
  width: undefined,

  autoOpen: true,
  primatyClass: 'red',

  buttons: {},

  callback: undefined,
  close: undefined,
  hideCloseBtn: false,
  header: true,
  css: {},
}

/**
 * EXAMPLE:
 *
 * // AJAX url test
 * new simpleDialog.dialog({
        title: 'Title',
        url: 'url',
        close: function () {},
        callback: function () {}
    });
 */

const simpleDialog = (function simpleDialog() {
  let inited = false
  let overlay
  const init = function init() {
    inited = true
    overlay = new Overlay()
  }

  return (params) => {
    if (!inited) {
      init()
    }

    const options = _.defaults(params, simpleDialogDefaults)
    let { type } = options
    let el
    let isOpen = false
    let isDestroyed = false

    let waitingWithOpening = false
    let waitingWithResize = false
    let ready = false
    const initDialog = function initDialog() {
      initDialogData()

      el = document.createElement('div')
      el.innerHTML = simpleDialogTpl({
        data: {
          title: options.title,
          content: _.isString(options.content) ? options.content : '',
          buttons: options.buttons,
          header: options.header,
        },
      })
      // eslint-disable-next-line prefer-destructuring
      el = el.children[0]
      el.style.opacity = '0'
      el.style[trans3d.t] = 'scale(1.3)'

      initDialogHeader()
      initDialogContent()
      initDialogButtons()

      // adding element to dom
      hide()
      document.body.appendChild(el)

      el.open = open
      el.close = close
      $(el).css(options.css)

      // listeners
      win.on('resize', onResize)
      win.on('keyup', onKeydown)

      onResize()

      if (options.autoOpen) {
        open()
      } else {
        hide()
      }

      if (!options.url && !options.iframe) {
        if (_.isFunction(options.callback)) {
          options.callback()
        }
      }
    }

    const initDialogData = function initDialogData() {
      // set types
      if (!type) {
        if (options.buttons) {
          if (options.buttons.yes && options.buttons.no) {
            type = 'confirm'
          } else if (options.buttons.ok) {
            type = 'message'
          }
        }
      }
      // init buttons
      _.forEach(options.buttons, (btn, id) => {
        if (btn === true) {
          btn = {}
        } else if (_.isFunction(btn)) {
          btn = {
            callback: btn,
          }
        }

        if (!btn.label) {
          if (id === 'yes') {
            btn.label = trans('Yes')
          } else if (id === 'no') {
            btn.label = trans('No')
          } else if (id === 'ok') {
            btn.label = trans('OK')
          } else {
            btn.label = trans(id)
          }
        }

        if (id === 'yes') {
          btn.primary = true
        }

        if (!btn.className) {
          if (btn.primary) {
            btn.className = options.primatyClass
          }
        }

        options.buttons[id] = btn
      })
    }

    const initDialogHeader = function initDialogHeader() {
      el.header = $(el).find('.simple-dialog-header')[0]
      el.$closeBtn = $(el).find('.simple-dialog-close-btn')
      if (type === 'confirm' || options.hideCloseBtn) {
        el.$closeBtn.css('display', 'none')
      } else {
        el.$closeBtn.click(close)
      }
    }

    const initDialogContent = function initDialogContent() {
      el.$contentBox = $(el).find('.simple-dialog-content-box')
      el.content = $(el).find('.simple-dialog-content')[0]

      if (_.isElement(options.content)) {
        options.contentEl = options.content
      }

      if (options.iframe) {
        el.className += ' iframe'
        options.contentEl = $(
          `<iframe width="${win.width * 0.8}" height="${win.height * 0.8}" src="${options.iframe}"></iframe>`,
        )[0]

        if (_.isFunction(options.callback)) {
          options.contentEl.onload = function onload() {
            options.callback(options.contentEl)
          }
        }
      }

      if (options.contentEl && (_.isElement(options.contentEl) || options.contentEl.length)) {
        if (options.contentEl.length) {
          options.contentEl = options.contentEl[0]
        }
        empty()
        el.content.appendChild(options.contentEl)
      }

      if (options.url) {
        empty()
        ready = false
      } else {
        ready = true
      }

      el.$form = el.$contentBox.find('form')
    }

    const initDialogButtons = function initDialogButtons() {
      _.forEach(options.buttons, (btn, id) => {
        const btnNode = $(el).find(`#${id}`)
        if (btnNode.length) {
          btnNode.click(() => {
            if (_.isFunction(btn.callback)) {
              btn.callback.call(el)
            }
            if (type === 'confirm' || type === 'message') {
              destroy()
            }
          })
        }
      })
    }

    const loadContent = function loadContent() {
      if (_.isString(options.url)) {
        overlay.loader(true)
        get(
          options.url,
          options.urlAsJson ? 'json' : 'html',
          (response) => {
            overlay.loader(false)

            let html = response
            if (options.urlAsJson) {
              html = response.data.lead + response.data.article
            }
            el.content.innerHTML = html
            el.$form = el.$contentBox.find('form')
            onResize()
            waitingWithOpening = false
            ready = true
            open()
            if (_.isFunction(options.callback)) {
              options.callback()
            }
          },
          () => {
            overlay.loader(false)

            close()
          },
        )
      } else {
        destroy()
      }
    }

    const empty = function empty() {
      el.content.innerHTML = ''
    }

    const open = function open() {
      if (isOpen) {
        return
      }

      overlay.show(options.overlayZIndex)
      if (!ready && options.url && !waitingWithOpening) {
        waitingWithOpening = true
        loadContent()
        return
      }

      show()

      el.style.display = ''
      isOpen = true

      if (waitingWithResize) {
        onResize()
      }

      if (el.$form.length) {
        el.$form.find('input').first().fp()
      }
    }

    const close = function close() {
      if (!el) {
        return
      } // if close action is runned 2 or more times
      overlay.hide()

      el.style.display = 'none'
      isOpen = false

      if (_.isFunction(options.close)) {
        options.close()
      }
    }

    const destroy = function destroy() {
      if (!isDestroyed) {
        isDestroyed = true
        close()
        if (el && el.parentNode) {
          el.parentNode.removeChild(el)
          el = undefined
        }
      }
    }

    const show = function show() {
      el.style.visibility = 'visible'
      setTimeout(() => {
        el.style.opacity = '1'
        el.style[trans3d.t] = 'scale(1)'
      }, 150)
    }

    const hide = function hide() {
      el.style.visibility = 'hidden'
    }

    const onResize = function onResize() {
      if (!isOpen) {
        waitingWithResize = true
        return
      }

      if (options.width) {
        let nw = options.width
        if (_.isFunction(nw)) {
          nw = nw()
        }

        if (_.isNumber(nw)) {
          nw += 'px'
        }

        if (_.isString) {
          el.style.width = nw
        }
      }

      el.style.left = 0
      el.style.top = 0
      el.$contentBox.css('height', 'auto')

      const currentWidth = el.offsetWidth
      let currentHeight = el.offsetHeight
      const dialogContentHeight = el.content.offsetHeight
      let dialogContentMaxHeight = currentHeight - 80

      if (currentHeight > win.height) {
        currentHeight = win.height - 10
        el.style.height = `${currentHeight}px`
      } else {
        el.style.height = ''
      }

      const newLeft = Math.round((win.width - currentWidth) / 2)
      const newTop = Math.round((win.height - currentHeight) / 2)

      el.style.left = `${newLeft}px`
      el.style.top = `${newTop}px`

      if (dialogContentHeight > dialogContentMaxHeight) {
        dialogContentMaxHeight =
          currentHeight -
          el.header.offsetHeight -
          parseInt(el.$contentBox.css('paddingTop'), 10) -
          parseInt(el.$contentBox.css('paddingBottom'), 10) -
          parseInt(el.$contentBox.css('marginTop'), 10) -
          parseInt(el.$contentBox.css('marginBottom'), 10)
        el.$contentBox.css('height', dialogContentMaxHeight)
      } else {
        el.$contentBox.css('height', 'auto')
      }

      waitingWithResize = false
    }

    const onKeydown = function onKeydown(key) {
      if (!isOpen) {
        return
      }

      if (key === 27) {
        // ESC
        close()
      }
    }

    initDialog()
    el.show = show
    el.hide = hide
    el.destroy = destroy
    el.removeCloseCallback = function removeCloseCallback() {
      options.close = undefined
    }
    el.onResize = onResize
    return el
  }
})()

// Shortcuts
const message = function message(text, arg2, close) {
  let title = trans('Message')
  if (_.isString(arg2)) {
    title = text
    text = arg2
  }

  return simpleDialog({
    title,
    content: text,
    type: 'message',
    buttons: { ok: true },
    close,
  })
}

const confirm = function confirm(text, yes, no) {
  return simpleDialog({
    title: trans('Confirm'),
    content: text,
    buttons: {
      yes: yes || true,
      no: no || true,
    },
  })
}

/**
 * Open link in dialog
 */
$.fn.openInDialog = function openInDialog(callback, options) {
  if (this.length > 1) {
    this.each(() => {
      $(this).openInDialog(callback, options)
    })
    return this
  }

  if (!options) {
    options = {}
  }
  if (_.isString(options)) {
    options = { title: options }
  }

  const $this = this
  let url
  let title
  let isInited = false
  let dialog
  const init = function init() {
    url = $this.attr('href')
    title = options.title || $this.attr('title') || $this.text() || ''

    dialog = simpleDialog({
      url,
      title,
      callback,
    })

    isInited = true
  }

  $this.click((e) => {
    if (!e.ctrlKey) {
      killEvent(e)
      if (options.cache === false || !isInited) {
        init()
      } else {
        dialog.open()
      }
    }
  })

  return $this
}

module.exports = {
  dialog: simpleDialog,
  message,
  confirm,
}
